import { gql } from "@apollo/client";
export const SAVE_OUT_OF_OFFICE = gql`
  mutation updateOutOfOffice($input: [OutOfOfficeInput]!) {
    updateOutOfOffice(input: $input) {
      correlationId
    }
  }
`;
